let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("chbbZ")).then(() => parcelRequire('4yiYq'));